"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _queryString = _interopRequireDefault(require("query-string"));
var _cookies = require("@kiwicom/cookies");
var _events = require("../../../consts/events");
var _api = require("../../auth/api");
var _context = require("../../log/context");
var _context2 = require("../../auth/context");
var _url = require("../../utils/url");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * TODO: move this to Overlord's Next middleware (needed for local development)
 */
const useOAuthRedirect = () => {
  const {
    log
  } = (0, _context.useLog)();
  const {
    onSetAuth
  } = (0, _context2.useAuth)();
  return React.useEffect(() => {
    const queryParams = _queryString.default.parse(window.location.search.substring(1));
    const {
      auth_token: token,
      error_code: error,
      oneTap
    } = queryParams;

    // no relevant query params found, skip
    if (!(token || error)) {
      return;
    }
    if (error) {
      log(_events.OAUTH_REDIRECT_ERROR, {});
    } else if (typeof token === "string") {
      (0, _api.getTokenUser)(token).then(user => {
        onSetAuth({
          type: "user",
          user,
          token
        });
        (0, _cookies.save)(_cookies.Cookie.UA_SESSION_TOKEN, token);
        log(_events.OAUTH_LOGIN_FROM_REDIRECT, {});
        if (oneTap != null) {
          log(_events.OAUTH_ONE_TAP_USED, {});
        }
      }).catch(err => log(_events.OAUTH_USER_RETRIEVAL_ERROR, {
        error: String(err)
      }));
    }
    const query = (0, _url.purgeQueryParameters)(queryParams, _url.oauthParamsToOmit);
    const newUrl = `${window.location.origin}${window.location.pathname}${query}`;
    window.history.replaceState({}, document.title, newUrl);
  });
};
var _default = useOAuthRedirect;
exports.default = _default;